import React, { useEffect, useState } from "react";
import Button from "../../extra/Button";
import { CLOSE_DIALOGUE } from "../../store/dialogue/dialogue.type";
import Input from "../../extra/Input";
import { connect, useDispatch, useSelector } from "react-redux";
import { createShowcase, updateShowcase } from "../../store/showcase/showcase.action";
import { getCategory } from "../../store/category/category.action";
import { apiInstanceFetch } from "../../../util/api";

const ShowcaseDialog = (props) => {
  const { dialogueData } = useSelector((state) => state.dialogue);
  const { category } = useSelector((state) => state.category);
  const dispatch = useDispatch();

  const [mongoId, setMongoId] = useState(null);
  const [title, setTitle] = useState("");
  const [productSource, setProductSource] = useState("categories");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [sortOrder, setSortOrder] = useState(0);
  const [isActive, setIsActive] = useState(true);

  // Product search state
  const [productSearch, setProductSearch] = useState("");
  const [productResults, setProductResults] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);

  const [error, setError] = useState({});

  useEffect(() => {
    dispatch(getCategory());
  }, [dispatch]);

  useEffect(() => {
    if (dialogueData) {
      setMongoId(dialogueData._id);
      setTitle(dialogueData.title || "");
      setProductSource(dialogueData.productSource || "categories");
      setSelectedCategories(dialogueData.categories?.map((c) => c._id) || []);
      setSortOrder(dialogueData.sortOrder || 0);
      setIsActive(dialogueData.isActive !== undefined ? dialogueData.isActive : true);
      setSelectedProducts(dialogueData.pinnedProducts || []);
    }
  }, [dialogueData]);

  const handleCategoryToggle = (catId) => {
    setSelectedCategories((prev) =>
      prev.includes(catId) ? prev.filter((id) => id !== catId) : [...prev, catId]
    );
  };

  const handleProductSearch = (value) => {
    setProductSearch(value);
    if (value.length < 2) {
      setProductResults([]);
      return;
    }
    setSearchLoading(true);
    apiInstanceFetch
      .get(`product/getRealProducts?start=1&limit=10&search=${encodeURIComponent(value)}`)
      .then((res) => {
        setProductResults(res.products || []);
        setSearchLoading(false);
      })
      .catch(() => setSearchLoading(false));
  };

  const handleAddProduct = (product) => {
    if (!selectedProducts.find((p) => p._id === product._id)) {
      setSelectedProducts((prev) => [...prev, product]);
    }
    setProductSearch("");
    setProductResults([]);
  };

  const handleRemoveProduct = (productId) => {
    setSelectedProducts((prev) => prev.filter((p) => p._id !== productId));
  };

  const handleSubmit = () => {
    if (!title.trim()) {
      return setError({ title: "Title is required!" });
    }

    const data = {
      title: title.trim(),
      productSource,
      categories: selectedCategories,
      pinnedProducts: selectedProducts.map((p) => p._id),
      sortOrder: parseInt(sortOrder) || 0,
      isActive,
    };

    if (mongoId) {
      dispatch(updateShowcase(data, mongoId));
    } else {
      dispatch(createShowcase(data));
    }
    dispatch({ type: CLOSE_DIALOGUE });
  };

  return (
    <div className="mainDialogue fade-in">
      <div className="Dialogue" style={{ maxWidth: "600px" }}>
        <div className="dialogueHeader">
          <div className="headerTitle fw-bold text-white">
            {mongoId ? "Edit Showcase" : "New Showcase"}
          </div>
          <div
            className="closeBtn"
            onClick={() => dispatch({ type: CLOSE_DIALOGUE })}
          >
            <i className="fa-solid fa-xmark"></i>
          </div>
        </div>
        <div className="dialogueMain" style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <div className="row">
            {/* Title */}
            <div className="col-12">
              <Input
                label="Title"
                id="title"
                type="text"
                value={title}
                placeholder="e.g. Trending Now, Holiday Offers"
                errorMessage={error.title}
                onChange={(e) => {
                  setTitle(e.target.value);
                  setError({});
                }}
              />
            </div>

            {/* Product Source */}
            <div className="col-12" style={{ marginTop: "10px" }}>
              <label className="text-white" style={{ fontSize: "14px", marginBottom: "5px", display: "block" }}>
                Product Source
              </label>
              <select
                className="form-input"
                value={productSource}
                onChange={(e) => setProductSource(e.target.value)}
                style={{
                  width: "100%",
                  padding: "8px 12px",
                  borderRadius: "5px",
                  background: "#2a2a2a",
                  color: "#fff",
                  border: "1px solid #444",
                }}
              >
                <option value="categories">From Categories</option>
                <option value="manual">Manual Pick</option>
                <option value="both">Both</option>
              </select>
            </div>

            {/* Categories - shown for "categories" or "both" */}
            {(productSource === "categories" || productSource === "both") && (
              <div className="col-12" style={{ marginTop: "10px" }}>
                <label className="text-white" style={{ fontSize: "14px", marginBottom: "5px", display: "block" }}>
                  Categories
                </label>
                <div
                  style={{
                    maxHeight: "150px",
                    overflowY: "auto",
                    border: "1px solid #444",
                    borderRadius: "5px",
                    padding: "8px",
                  }}
                >
                  {category?.map((cat) => (
                    <div
                      key={cat._id}
                      className="form-check"
                      style={{ marginBottom: "4px" }}
                    >
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`cat-${cat._id}`}
                        checked={selectedCategories.includes(cat._id)}
                        onChange={() => handleCategoryToggle(cat._id)}
                        style={{ cursor: "pointer" }}
                      />
                      <label
                        className="form-check-label text-white"
                        htmlFor={`cat-${cat._id}`}
                        style={{ cursor: "pointer" }}
                      >
                        {cat.name}
                      </label>
                    </div>
                  ))}
                  {(!category || category.length === 0) && (
                    <p className="text-white mb-0" style={{ fontSize: "13px" }}>No categories found</p>
                  )}
                </div>
              </div>
            )}

            {/* Pinned Products - shown for "manual" or "both" */}
            {(productSource === "manual" || productSource === "both") && (
              <div className="col-12" style={{ marginTop: "10px" }}>
                <label className="text-white" style={{ fontSize: "14px", marginBottom: "5px", display: "block" }}>
                  Pinned Products
                </label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="Search products..."
                  value={productSearch}
                  onChange={(e) => handleProductSearch(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    borderRadius: "5px",
                    background: "#2a2a2a",
                    color: "#fff",
                    border: "1px solid #444",
                    marginBottom: "5px",
                  }}
                />
                {searchLoading && (
                  <p className="text-white" style={{ fontSize: "12px" }}>Searching...</p>
                )}
                {productResults.length > 0 && (
                  <div
                    style={{
                      maxHeight: "120px",
                      overflowY: "auto",
                      border: "1px solid #444",
                      borderRadius: "5px",
                      marginBottom: "5px",
                    }}
                  >
                    {productResults.map((p) => (
                      <div
                        key={p._id}
                        onClick={() => handleAddProduct(p)}
                        style={{
                          padding: "6px 10px",
                          cursor: "pointer",
                          borderBottom: "1px solid #333",
                          color: "#fff",
                          fontSize: "13px",
                        }}
                        onMouseEnter={(e) => (e.target.style.background = "#333")}
                        onMouseLeave={(e) => (e.target.style.background = "transparent")}
                      >
                        {p.productName} - ${p.price}
                      </div>
                    ))}
                  </div>
                )}
                {/* Selected products as chips */}
                <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
                  {selectedProducts.map((p) => (
                    <span
                      key={p._id}
                      style={{
                        background: "#F0C420",
                        color: "#333",
                        padding: "4px 10px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      {p.productName}
                      <i
                        className="fa-solid fa-xmark"
                        style={{ cursor: "pointer", fontSize: "10px" }}
                        onClick={() => handleRemoveProduct(p._id)}
                      ></i>
                    </span>
                  ))}
                </div>
              </div>
            )}

            {/* Sort Order */}
            <div className="col-12">
              <Input
                label="Sort Order"
                id="sortOrder"
                type="number"
                value={sortOrder}
                placeholder="Display order (lower = first)"
                onChange={(e) => setSortOrder(parseInt(e.target.value) || 0)}
              />
            </div>

            {/* Active Toggle */}
            <div className="col-12">
              <div className="form-check" style={{ marginTop: "10px" }}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="isActive"
                  checked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                  style={{ cursor: "pointer" }}
                />
                <label
                  className="form-check-label text-white"
                  htmlFor="isActive"
                  style={{ cursor: "pointer" }}
                >
                  Active
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="dialogueFooter">
          <div className="dialogueBtn">
            <Button
              btnName={mongoId ? "Update" : "Submit"}
              btnColor="btnBlackPrime text-light"
              style={{ borderRadius: "5px", width: "80px" }}
              newClass="me-2"
              onClick={handleSubmit}
            />
            <Button
              btnName="Close"
              btnColor="myCustomButton"
              style={{ borderRadius: "5px", width: "80px" }}
              onClick={() => dispatch({ type: CLOSE_DIALOGUE })}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { createShowcase, updateShowcase })(ShowcaseDialog);
